import useStateView from './useStateView';
import { localeView } from '../state/views';
import globalMessages from '../constants/globalMessages';
import { formatDateWithString } from '../utils/date';
import { formatMessage } from '../utils/formatMessage';

const savedDelimiters = {};

const getLocaleDelimiters = (locale) => {
  if (locale in savedDelimiters === false) {
    const str = (1000.1).toLocaleString(locale);

    savedDelimiters[locale] = {
      thousand: isNaN(parseInt(str[1], 10)) ? str[1] : false,
      decimal: str[str.length - 2],
    };
  }

  return savedDelimiters[locale];
};

export default (allMessages = {}) => {
  allMessages = { ...globalMessages, ...allMessages };

  const [savedLocale] = useStateView(localeView);

  const locale = savedLocale in globalMessages ? savedLocale : 'en';

  const messages = {
    ...globalMessages[locale],
    ...(locale in allMessages ? allMessages[locale] : allMessages.en || {}),
  };

  const delimiters = getLocaleDelimiters(locale);

  return {
    locale,
    messages,
    delimiters,
    formatMessage,
    formatDate: (date, format) => {
      date = new Date(date);

      if (typeof format === 'string') {
        return formatDateWithString(date, format);
      }

      date.setUTCHours(11);
      return date.toLocaleDateString(locale, format);
    },
  };
};
